export default {"src":"/_next/static/media/how-we-get-the-right-sizing-4.7e6e5983.svg","height":189,"width":192,"blurWidth":0,"blurHeight":0};